const PieCustomLegendPlugin = (function() {
  let functions = {};

  functions.transparentizeColor = (hex, opacity) => {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  functions.getOrCreateLegendList = (chart, id) => {
    const legendContainer = document.getElementById(id);
    let listContainer = legendContainer?.querySelector('ul');

    if (!listContainer) {
      listContainer = document.createElement('ul');
      listContainer.style.display = 'flex';
      listContainer.style.flexDirection = 'column';
      listContainer.style.rowGap = '2px';
      listContainer.style.margin = 0;
      listContainer.style.padding = 0;

      legendContainer.appendChild(listContainer);
    }

    return listContainer;
  };

  functions.htmlLegendPlugin = () => {
    return {
      id: 'htmlLegend',
      afterUpdate(chart, args, options) {
        const ul = functions.getOrCreateLegendList(chart, options.containerID);

        // Remove old legend items
        while (ul.firstChild) {
          ul.firstChild.remove();
        }

        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);

        items.forEach((item) => {
          const { type: chartType } = chart.config;

          const currentDataset = ['pie', 'doughnut'].includes(chartType)
            ? chart.data.datasets[0]
            : chart.data.datasets[item.datasetIndex];

          const li = document.createElement('li');
          li.style.fontSize = '10px';
          li.style.alignItems = 'center';
          li.style.cursor = 'pointer';
          li.style.display = 'flex';
          li.style.flexDirection = 'row';
          li.style.rowGap = '5px';
          li.style.justifyContent = 'space-between';
          li.style.alignItems = 'center';
          li.style.padding = '0 16px';
          li.style.width = '100%';
          li.style.height = '30px';
          li.style.borderRadius = '4px';
          li.style.backgroundColor = functions.transparentizeColor(item.fillStyle, 0.1);
          !!item.hidden && (li.style.filter = 'grayscale(100%)');

          li.onclick = () => {
            const projectStatus = (() => {
              switch (item.text) {
                case 'Collecte en cours':
                  return 'collecting';
                case 'Clôturé':
                  return 'closed';
                case 'Financé':
                  return 'succeeded';
                case 'Remboursé':
                  return 'refunded';
                case 'En retard':
                  return 'late';
                default:
                  return null;
              }
            })();

            const projectTypology = (() => {
              switch(item.text) {
                case 'Marchand de biens':
                  return 'assets_vendor';
                case 'Promotion immobilière':
                  return 'real_estate_promotion';
                case 'Ligne de trésorerie':
                  return 'liquidity_line';
              }
            })();

            if (projectStatus) {
              window.location.href = `investissements?q[project_calculated_status_in]=${projectStatus}`;
            } else if (projectTypology) {
              window.location.href = `investissements?q[project_typology_eq]=${projectTypology}`;
            } else if (['pie', 'doughnut'].includes(chartType)) {
              // Pie and doughnut charts only have a single dataset and visibility is per item
              chart.toggleDataVisibility(item.index);
            } else {
              chart.setDatasetVisibility(
                item.datasetIndex,
                !chart.isDatasetVisible(item.datasetIndex)
              );
            }

            chart.update();
          };

          const colorBoxSvg = `<svg
              width="24"
              height="16"
              viewBox="0 0 24 16"
              fill="none"
            >
              <path
                d="M5.60806 0L11.6974 2.13657L17.7626 0L23.4668 1.79666V11.654L11.6974 16L0.0001297 11.654V1.79666L5.60806 0Z"
                fill="currentColor"
              />
            </svg>`;
          const colorBox = document.createElement('div');
          colorBox.style.color = item.fillStyle;
          colorBox.style.marginRight = '12px';
          colorBox.insertAdjacentHTML('beforeend', colorBoxSvg);

          // Label
          const labelContainer = document.createElement('p');
          labelContainer.style.fontWeight = 400;
          labelContainer.style.color = item.fillStyle;
          labelContainer.style.display = 'block';
          labelContainer.style.marginRight = '8px';
          labelContainer.style.marginBottom = '0px';
          labelContainer.style.fontFamily = 'Montserrat, sans-serif';
          labelContainer.style.textDecoration = item.hidden ? 'line-through' : '';

          const label = document.createTextNode(item.text);
          labelContainer.appendChild(label);
          const countContainer = document.createElement('span');
          countContainer.style.display = 'block';
          countContainer.style.fontWeight = 600;
          countContainer.style.color = item.fillStyle;
          countContainer.style.fontFamily = 'Montserrat, sans-serif';
          countContainer.style.marginLeft = 'auto';
          countContainer.style.textDecoration = item.hidden ? 'line-through' : '';

          const value = currentDataset.data[item.index];
          const count = document.createTextNode(value);
          countContainer.appendChild(count);

          li.appendChild(colorBox);
          li.appendChild(labelContainer);
          li.appendChild(countContainer);

          ul.appendChild(li);
        });
      },
    };
  }

  return functions;
})();

// Expose top-level declarations as globals (pre-bundler concatenation behavior).
window.PieCustomLegendPlugin = PieCustomLegendPlugin;
